var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20978_43111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00032 9.66002C5.9999 9.7416 6.01558 9.82245 6.04647 9.89796C6.07736 9.97346 6.12284 10.0421 6.18032 10.1L13.4103 17.33L14.3003 16.45L7.51032 9.66002L14.2603 2.91002L13.3803 2.02002L6.15032 9.20002C6.09576 9.26272 6.05436 9.33576 6.02859 9.41478C6.00283 9.49381 5.99321 9.57721 6.00032 9.66002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0491 10.4099C12.4688 10.4099 12.8091 10.0696 12.8091 9.64989C12.8091 9.23016 12.4688 8.88989 12.0491 8.88989C11.6293 8.88989 11.2891 9.23016 11.2891 9.64989C11.2891 10.0696 11.6293 10.4099 12.0491 10.4099Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20978_43111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.3,
    height: 15.31,
    fill: "currentColor",
    transform: "translate(6 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.069b0f7c.svg";
export { ForwardRef as ReactComponent };